export const FETCH_TRANSLATIONS = 'CUSTOMIZE/TRANSLATIONS/FETCH_REQUEST';
export const FETCH_TRANSLATIONS_SUCCESS = 'CUSTOMIZE/TRANSLATIONS/FETCH_SUCCESS';
export const FETCH_TRANSLATIONS_FAILURE = 'CUSTOMIZE/TRANSLATIONS/FETCH_FAILURE';
